import { memo, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import ReusableGrid from '../../../components/Grid';
import { useFooter } from './hooks/useFooter';

const TableItem = ({ item, columns, absertCodesList, selOrder }) => {
  const typeMeasuring = useMemo(() => {
    return (
      selOrder === 'Acc' &&
      absertCodesList
        .find((code) => code.name === item.name)
        ?.hoursOrShifts?.replace(/^\(|\)$/g, '')
    );
  }, [absertCodesList, item, selOrder]);

  const footer = useFooter(item.rows, typeMeasuring, selOrder);
  return (
    <Box mb={4}>
      <Typography variant="h6" fontWeight={600} mb={2}>
        {item.name}
      </Typography>
      <Box sx={{ backgroundColor: 'red' }}>
        <ReusableGrid
          columns={columns}
          rows={item.rows}
          footer={footer}
          style={{ backgroundColor: '#f7f7f7 !important' }}
        />
      </Box>
    </Box>
  );
};

export default memo(TableItem);
